import type { StatusColor } from '@ztechapps/common.contract'
import { ShipmentStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

export type LogisticShipmentStatusDetailType = {
  label: string
} & StatusColor

// Each tone resolves to a CSS custom property declared in libs/webui/util/src/Status/StatusColor.scss, the one place a
// status colour's value lives; it resolves only in a browser that has loaded that stylesheet. Every key is computed from
// the enum so a key can never drift from the literal the gateway stores. `label` is the display text, which the
// gateway's own spelling is not — `completed` is shown as "Label Created". Typing the map as a Record over the enum is
// what makes a missing entry a compile error.
export const LogisticShipmentStatus: Record<ShipmentStatusEnum, LogisticShipmentStatusDetailType> = {
  [ShipmentStatusEnum.Processing]: {
    label: 'Processing',
    tone: StatusToneEnum.InProgress,
  },
  [ShipmentStatusEnum.Completed]: {
    label: 'Label Created',
    tone: StatusToneEnum.InProgress,
  },
  [ShipmentStatusEnum.InTransit]: {
    label: 'In Transit',
    tone: StatusToneEnum.InProgress,
  },
  [ShipmentStatusEnum.Delivered]: {
    label: 'Delivered',
    tone: StatusToneEnum.Active,
  },
  [ShipmentStatusEnum.Error]: {
    label: 'Error',
    tone: StatusToneEnum.Failure,
  },
  [ShipmentStatusEnum.Voided]: {
    label: 'Voided',
    tone: StatusToneEnum.Cancelled,
  },
}
